import { Alert, Button, Modal } from "antd";
import { isEmpty } from "lodash";
import { Trans, useTranslation } from "react-i18next";

interface ResetPasswordModalProps {
  open: boolean;
  onCancelModal: () => void;
  onSendEmail: () => void;
  email: string;
  resetPasswordError: string[];
  isSendingEmail: boolean;
}

export default function ResetPasswordModal(props: ResetPasswordModalProps) {
  const { open, onCancelModal, onSendEmail, email, resetPasswordError, isSendingEmail } = props;
  const { t } = useTranslation();
  return (
    <Modal
      title={t("myAccount.resetPasswordModal.heading")}
      open={open}
      closable={true}
      onCancel={onCancelModal}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={onCancelModal} disabled={isSendingEmail}>
          {t("myAccount.resetPasswordModal.cancelCTA")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={onSendEmail}
          disabled={isSendingEmail}
          loading={isSendingEmail}
        >
          {t("myAccount.resetPasswordModal.sendEmailCTA")}
        </Button>
      ]}
    >
      {!isEmpty(resetPasswordError) && (
        <Alert
          type="error"
          style={{ marginBottom: 24 }}
          message={resetPasswordError.join(" ")}
          showIcon
        />
      )}
      <Trans>{t("myAccount.resetPasswordModal.description", { email: email })}</Trans>
    </Modal>
  );
}
